<template>
  <div :class="handleStyleClass()" role="tablist" ref="accordion">
    <b-card no-body class="mb-2 border">
      <b-card-header header-tag="header" class="p-0" role="tab">
        <b-button block v-b-toggle:[id] class="text-left" variant="transparent">
          {{ title }}
          <span class="float-right" v-if="rightTitle">
            {{ rightTitle }}
          </span>
        </b-button>
      </b-card-header>
      <b-collapse
        :id="id"
        :visible="isVisible"
        accordion="my-accordion"
        role="tabpanel"
        @hide="hide"
        @show="show"
      >
        <b-card-body>
          <slot />
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  data() {
    return {
      isVisible: true,
    };
  },
  props: {
    id: {
      type: String,
    },
    title: {
      type: String,
    },
    rightTitle: {
      type: String,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleStyleClass() {
      if (this.error) return 'accordion-error';
      if (this.isVisible) return 'accordion-success';
      return 'accordion';
    },
    getAccordionElement() {
      return this.$refs.accordion;
    },
    show() {
      if (this.error) return;
      this.isVisible = true;
      this.getAccordionElement().classList.remove('accordion');
      this.getAccordionElement().classList.add('accordion-success');
    },
    hide() {
      if (this.error) return;
      this.getAccordionElement().classList.remove('accordion-success');
      this.getAccordionElement().classList.add('accordion');
    },
  },
};
</script>

<style scoped>
span {
  font-size: 12px;
}
</style>
